import {
  BRAND_ROUTE_REGEX,
  CATALOG_BRAND_ROUTE_REGEX,
  CATALOG_ROUTE_REGEX,
  SortByOption,
} from '@marketplace-web/catalog/catalog-data'

import { CatalogFilterParams } from '../types/closet-promotions'

const parseToNumberArray = (param: string | Array<string> | undefined | null): Array<number> => {
  if (!param) return []

  const stringArray = Array.isArray(param) ? param : [param]

  return stringArray.map(id => parseInt(id, 10)).filter(id => Number.isFinite(id))
}

const parseToStringOrUndefined = (
  param: string | Array<string> | undefined,
): string | undefined => {
  if (Array.isArray(param)) return param.length > 0 ? param[0] : undefined

  return param
}

export const parseCatalogUrlParams = (
  searchParams: Record<string, string | Array<string> | undefined>,
  relativeUrl: string,
): CatalogFilterParams => {
  const catalogRouteMatch = relativeUrl.match(CATALOG_ROUTE_REGEX)
  const brandRouteMatch = relativeUrl.match(BRAND_ROUTE_REGEX)
  const catalogBrandRouteMatch = relativeUrl.match(CATALOG_BRAND_ROUTE_REGEX)

  let catalogIds: Array<number> = []
  let brandId: string | undefined

  if (catalogRouteMatch) {
    catalogIds = catalogRouteMatch[1]
      ? [parseInt(catalogRouteMatch[1], 10)].filter(Number.isFinite)
      : []
  } else if (brandRouteMatch) {
    brandId = brandRouteMatch[1] || undefined
  } else if (catalogBrandRouteMatch) {
    catalogIds = catalogBrandRouteMatch[1]
      ? [parseInt(catalogBrandRouteMatch[1], 10)].filter(Number.isFinite)
      : []
    brandId = catalogBrandRouteMatch[2] || undefined
  } else {
    catalogIds = parseToNumberArray(searchParams.catalog)
  }

  const selectedDynamicFilters: Record<string, string> = {}

  if (!(catalogRouteMatch || brandRouteMatch || catalogBrandRouteMatch)) {
    Object.keys(searchParams)
      .filter(key => key.endsWith('_ids'))
      .forEach(key => {
        const ids = parseToNumberArray(searchParams[key])
        if (ids.length > 0) {
          selectedDynamicFilters[key] = ids.join(',')
        }
      })
  }

  if (brandId) {
    const parsedBrandId = parseInt(brandId, 10)
    if (Number.isFinite(parsedBrandId)) {
      selectedDynamicFilters.brand_ids = parsedBrandId.toString()
    }
  }

  return {
    filters: {
      search_text: parseToStringOrUndefined(searchParams.search_text),
      catalog_ids: catalogIds.length > 0 ? catalogIds.join(',') : undefined,
      price_from: parseToStringOrUndefined(searchParams.price_from),
      price_to: parseToStringOrUndefined(searchParams.price_to),
      currency: parseToStringOrUndefined(searchParams.currency),
      order:
        (parseToStringOrUndefined(searchParams.order) as SortByOption) || SortByOption.Relevance,
      catalog_from: parseToStringOrUndefined(searchParams.catalog_from),
      disable_search_saving: Boolean(searchParams.disable_search_saving) || undefined,
    },
    dynamicFilters: selectedDynamicFilters,
  }
}
